export const NAVIGATION_BAR_WIDTH = '20'
